export default __webpack_public_path__ + "static/media/rodrigovasconcelos.91fb94f4.png";